// Settings configuration 
export const settingsData = [

  {
    key: "schoolSetting",
    label: "School Settings",
    children: [
            {
        key: "school",
        label: "School",
        link: "/schoolSettings/schoolSetting/school",
        description: "Manage school profile and basic information",
      },
      {
        key: "requiredDocument",
        label: "Required Documents",
        link: "/schoolSettings/studentSetting/requiredDocument",
        description: "Manage student required document settings ",
      },
    ],
  },
];
